<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("gallery.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="sessionStorage(search)"
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <router-link to="/societyadmin/gallery/add" tag="button">
                  <v-btn class="primary">
                    <v-icon left> mdi-plus </v-icon>
                    Add Album
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7">
            <v-row>
              <v-col
                v-for="item in filteredGalleries"
                :key="item.id"
                :id="item.id"
                class="d-flex child-flex"
                cols="2"
              >
                <v-card>
                  <router-link :to="'/societyadmin/gallery/view/' + item.id">
                    <v-img
                      :src="API_BASE_URL + '/uploads/' + item.picture_url"
                      :lazy-src="API_BASE_URL + '/uploads/' + item.picture_url"
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </router-link>
                  <v-btn
                    icon
                    color="secondary"
                    name="delete_gallery"
                    title="Delete Gallery"
                    @click="confirmDelete(item.id)"
                    style="display: inline-block; margin-top: -15px"
                  >
                    <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                  </v-btn>
                  <div
                    class="text-truncate"
                    style="
                      width: 80px;
                      display: inline-block;
                      margin-top: 8px;
                      font-size: 16px;
                      text-align: center;
                    "
                  >
                    {{ item.title }}
                  </div>
                  <v-btn
                    icon
                    color="secondary"
                    name="edit_gallery"
                    title="Edit Gallery"
                    style="display: inline-block; float: right"
                    :to="'/societyadmin/gallery/edit/' + item.id"
                  >
                    <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>

            <!-- <v-data-table
              :headers="headers"
              :items="galleries"
              :search="search"
               class="elevation-3"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  class="col-md-6"
                  @input="sessionStorage(search)"
                ></v-text-field>
              </template>
              <template v-slot:item.title="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.title }}
                </div>
              </template>
              <template v-slot:item.picture_url="{ item }">
                <v-avatar
                  size="40"
                  v-if="item && item.picture_url != null"
                  class="mb-3 mt-3"
                >
                  <v-img
                    :src="API_BASE_URL + '/uploads/' + item.picture_url"
                    :alt="item.name"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <v-avatar
                  v-else
                  color="primary  primary--text"
                  class="white--text mb-3 mt-3"
                  size="40"
                >
                  <span class="fontsize-11 white--text">
                    <span class="fontsize-11 white--text">{{
                      item.title ? item.title.charAt(0) : ""
                    }}</span></span
                  >
                </v-avatar>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="secondary"
                  name="view_gallery"
                  title="View Gallery"
                  style="margin-left: -10px"
                  :to="'/societyadmin/gallery/view/' + item.id"
                >
                  <img src="@/components/icons/view.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="edit_gallery"
                  title="Edit Gallery"
                  :to="'/societyadmin/gallery/edit/' + item.id"
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_gallery"
                  title="Delete Gallery"
                  @click="confirmDelete(item.id)"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>
            </v-data-table> -->
          </v-card-text>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2"> Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteGallery(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="deleteDialog = false">
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  data() {
    return {
      search: "",
      // dropOptions: {
      // url: "https://httpbin.org/post"
      //  },
      headers: [
        {
          text: `${this.$t("gallery.headers.profile")}`,
          value: "picture_url",
          width: "30%",
        },
        {
          text: `${this.$t("gallery.headers.title")}`,
          value: "title",
          width: "30%",
        },
        {
          text: `${this.$t("gallery.headers.actions")}`,
          value: "actions",
          sortable: false,
          width: "15%",
        },
      ],
      user: {},
      addPermissionDialog: false,
      deleteDialog: false,
      galleries: [],
      delete_id: "",
    };
  },
  computed: {
    filteredGalleries() {
      if (!this.search) return this.galleries;
      const searchLower = this.search.toLowerCase();
      return this.galleries.filter((item) =>
        item.title.toLowerCase().includes(searchLower)
      );
    },
  },
  // components: {
  //   vueDropzone: vue2Dropzone
  // },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getGalleries() {
      let _self = this;
      _self.$axios.get("societyadmin/gallery").then((response) => {
        let data = response.data;
        console.log(data);
        if (data.status) {
          _self.galleries = data.galleries;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
          if (data.type == "invalid") {
            localStorage.removeItem("user");
            _self.$router.push({ path: "/societyadmin/login" });
          }
        }
      });
    },
    deleteGallery(gallery_id) {
      let _self = this;
      _self.$axios
        .delete("societyadmin/gallery/" + gallery_id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.galleries.filter((record) => {
              if (record.id != gallery_id) {
                return record;
              }
            });
            this.getGalleries();
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("gallery_search");
      } else {
        sessionStorage.setItem("gallery_search", search);
      }
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    this.getGalleries();
    this.search = sessionStorage.getItem("gallery_search");
  },
};
</script>
